<template>
  <el-row class="auth-container flex-full-xs flex-column-items-xs mobile-position-fixed">
    <el-col>
      <el-row
        type="flex"
        justify="center"
        class="links"
      >
        <el-col class="box">
          <router-link
            :to="{ name: 'Login' }"
            class="login-link"
          >
            {{ $t('login.login-text') }}
          </router-link>
          <router-link
            :to="{ name: 'SignUp' }"
            class="signup-link"
          >
            {{ $t('login.sign-up-text') }}
          </router-link>
          <div class="clearfix" />
          <el-row
            type="flex"
            justify="center"
            class="auth-form"
          >
            <el-form
              v-loading.fullscreen.lock="loading"
              class="login-signup-form"
              :label-position="labelPosition"
              :model="form"
              :element-loading-background="'rgba(0,0,0,0.7)'"
              @submit.native.prevent="onSubmit"
            >
              <el-col>
                <el-form-item :error="error('email')">
                  <el-input
                    v-model="form.email"
                    :placeholder="$t('login.email.placeholder')"
                    @change="change('email');change('global')"
                  >
                    <i
                      slot="prefix"
                      class="icon-envelope"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :error="error('password') || error('global')">
                  <el-input
                    v-model="form.password"
                    :placeholder="$t('login.password.placeholder')"
                    :type="showPassword ? 'text': 'password'"
                    @change="change('password');change('global')"
                  >
                    <i
                      slot="prefix"
                      class="icon-lock"
                    />
                    <i
                      slot="suffix"
                      :class="showPassword ? 'icon-blind' : 'icon-eye'"
                      @click="showPassword = !showPassword"
                    />
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-button
                    class="submit-button"
                    native-type="submit"
                  >
                    {{ $t('login.login-text') }}
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col class="text-center">
                <el-button
                  class="forgot-pass"
                  @click="openResetPasswordBox = true"
                >
                  {{ $t('login.forgot-password') }}
                </el-button>
              </el-col>
            </el-form>
            <el-dialog
              class="custom-auth-box"
              :class="{isMobile: isMobile}"
              :title="$t('login.forgot.password.dialog.title')"
              :modal-append-to-body="false"
              :visible.sync="openResetPasswordBox"
            >
              <span>{{ $t('login.forgot.password.dialog.body.title') }}</span>
              <el-form :model="resetForm">
                <el-form-item
                  :label="$t('login.forgot.password.dialog.label')"
                  :error="error('reset-email') || error('reset-global')"
                >
                  <el-input
                    v-model="resetForm.email"
                    autocomplete="off"
                  />
                </el-form-item>
              </el-form>
              <span
                slot="footer"
                class="dialog-footer"
              >
                <el-button @click="openResetPasswordBox = false">{{ $t('login.forgot.password.dialog.cancel') }}</el-button>
                <el-button
                  type="primary"
                  @click="resetPass"
                >{{ $t('login.forgot.password.dialog.confirm') }}</el-button>
              </span>
            </el-dialog>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="flex-full-xs flex-column-items-xs">
      <el-row class="signup flex-full-xs flex-column-items-xs">
        <span>{{ $t('login.have-account') }}
          <router-link :to="{ name: 'SignUp' }">&nbsp;{{ $t('login.sign-up-text') }}<i class="icon-arrow-r" /></router-link>
        </span>
      </el-row>
    </el-col>
    <el-col class="text-center flex-full-xs flex-column-items-xs">
      <router-link
        :to="{ name: 'Home' }"
        tag="button"
        class="skip-button"
      >
        {{ $t('login.skip-text') }}
      </router-link>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from 'vuex';
import Form from '../components/Core/ResourcePage';

export default {
  extends: Form,
  data() {
    return {
      labelPosition: 'left',
      showPassword: false,
      openResetPasswordBox: false,
      form: {
        email: '',
        password: '',
        reTypePassword: '',
      },
      resetForm: {
        email: '',
      },
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      user: state => state.auth.user,
    }),
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.$store
        .dispatch('login', { credentials: { ...this.form } })
        .then(() => {
          this.loading = false;
          this.$router.push({ name: 'Home' });
        })
        .catch(({ response }) => {
          this.$message({ type: 'error',
            message: ` ${this.$t('message.login.validation.error')}`,
          });
          this.onFormError(response);

          this.loading = false;
        });
    },
    resetPass() {
      this.loading = true;
      this.$store.dispatch('resetPassword', { credentials: { ...this.resetForm } })
        .then(() => {
          this.loading = false;
          this.$message({ type: 'success',
            message: ` ${this.$t('message.reset-password.sent')}`,
          });
          this.$router.push({ name: 'Welcome' });
        })
        .catch(({ response }) => {
          this.loading = false;
          if (response.status === 422) {
            // console.log(response.data.errors);
            this.errors = Object.keys(response.data.errors)
              .reduce((acc, key) => ({
                ...acc,
                [`reset-${key}`]: response.data.errors[key],
              }), {});
          }
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/LogIn.vue